import { makeRequest } from 'utils/requestLogger';

export const createIdeaCloud = (roundtableID) =>
  makeRequest('get', `/api/roundtables/${roundtableID}/idea-cloud`);

export const createSandboxIdeaCloud = () =>
  makeRequest('get', `/api/roundtables/123/idea-cloud-sandbox`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/dataVisualization/createIdeaCloud.js